import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Button, Card, CardContent, CardHeader, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Switch, Typography,
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import axios from 'axios';
import { apiHost } from '../utils/apiHost';
import { bacaLaci } from '../struk/laciKasir';

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}`;
};
const api = axios.create({ baseURL: getApiBaseUrl(), withCredentials: true });

/**
 * Pengaturan laci kasir per cabang (tab Laci Kasir di menu Struk): terpasang atau tidak, buka otomatis saat struk tunai dicetak atau hanya
 * manual, dan pin laci pada printer (2 atau 5). Laci disambung ke printer struk lewat kabel RJ11 dan dibuka dengan perintah ESC/POS.
 */
export const StrukLaci = ({ cabangUuid, konfigurasi, mutate }) => {
  const [aktif, setAktif] = useState(false);
  const [otomatis, setOtomatis] = useState(true);
  const [pin, setPin] = useState(2);
  const [menyimpan, setMenyimpan] = useState(false);
  const [umpanBalik, setUmpanBalik] = useState(null);

  useEffect(() => {
    const l = bacaLaci(konfigurasi);
    setAktif(l.aktif);
    setOtomatis(l.otomatis);
    setPin(l.pin);
  }, [konfigurasi]);

  const simpan = async () => {
    setMenyimpan(true);
    setUmpanBalik(null);
    try {
      await api.put('/updatekonfigurasicabang', { cabangUuid, laciKasir: { aktif, otomatis, pin } });
      await mutate();
      setUmpanBalik({ type: 'success', msg: 'Pengaturan laci kasir disimpan. Berlaku di kasir web dan aplikasi HP (saat berikutnya terhubung).' });
    } catch (err) {
      setUmpanBalik({ type: 'error', msg: err.response?.data?.msg || err.response?.data?.message || 'Gagal menyimpan pengaturan laci kasir.' });
    } finally {
      setMenyimpan(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 760 }}>
      <Alert severity="info" sx={{ mb: 2 }}>
        Laci kasir dihubungkan ke printer struk lewat kabel RJ11, lalu dibuka oleh perintah dari aplikasi. Hanya printer Bluetooth yang
        mendukungnya: mencetak lewat jendela cetak browser tidak membuka laci. Printer harus punya port laci.
      </Alert>

      <Card sx={{ mb: 2 }}>
        <CardHeader
          title="Laci kasir terpasang"
          subheader="Aktifkan bila printer kasir cabang ini tersambung ke laci uang."
          action={<Switch checked={aktif} onChange={(e) => setAktif(e.target.checked)} disabled={menyimpan} inputProps={{ 'aria-label': 'Laci kasir terpasang' }} />}
        />
        {aktif && (
          <CardContent>
            <FormControl sx={{ mb: 2, display: 'block' }}>
              <FormLabel>Kapan laci terbuka</FormLabel>
              <RadioGroup value={otomatis ? 'otomatis' : 'manual'} onChange={(e) => setOtomatis(e.target.value === 'otomatis')}>
                <FormControlLabel value="otomatis" control={<Radio />} label="Otomatis saat struk pembayaran tunai dicetak (dan tombol Buka Laci)" />
                <FormControlLabel value="manual" control={<Radio />} label="Hanya lewat tombol Buka Laci" />
              </RadioGroup>
            </FormControl>
            <FormControl sx={{ display: 'block' }}>
              <FormLabel>Pin laci pada printer</FormLabel>
              <RadioGroup row value={String(pin)} onChange={(e) => setPin(Number(e.target.value))}>
                <FormControlLabel value="2" control={<Radio />} label="Pin 2 (umum)" />
                <FormControlLabel value="5" control={<Radio />} label="Pin 5" />
              </RadioGroup>
              <Typography variant="caption" color="text.secondary">
                Bila laci tidak terbuka dengan pin 2, coba pin 5 (tergantung kabel dan merek printer).
              </Typography>
            </FormControl>
          </CardContent>
        )}
      </Card>

      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Pembayaran QRIS dan non-tunai tidak membuka laci. Pembayaran bagi (split) dan uang muka (DP) membuka laci bila ada bagian tunai.
        Tombol Buka Laci (kasir web dan aplikasi) dicatat sebagai aktivitas Penting di Log Aktivitas.
      </Typography>

      {umpanBalik && <Alert severity={umpanBalik.type} sx={{ mb: 2 }} onClose={() => setUmpanBalik(null)}>{umpanBalik.msg}</Alert>}
      <Button variant="contained" startIcon={<SaveIcon />} onClick={simpan} disabled={menyimpan}>
        {menyimpan ? 'Menyimpan…' : 'Simpan'}
      </Button>
    </Box>
  );
};
